/**
 * Normalise criteria.
 *
 * @param criteria - Original concat criteria.
 * @param delimiter - Criteria delimiter.
 * @returns normalized concat criteria.
 *
 * @public
 * @remarks
 * Normalises criteria, as the order of filters should not matter, also gets rid of spaces.
 * @privateRemarks
 * Can we use the criteria builder for this and related criteria stuff within datasources?
 */
export function normaliseCriteria(criteria, delimiter = ';') {
    if (!criteria) {
        return criteria;
    }
    return criteria
        .split(delimiter)
        .map((s) => s.trim())
        .sort((a, b) => a.localeCompare(b))
        .join(delimiter);
}
